import { createTheme } from '@mui/material/styles';
const Theme = createTheme({
    palette: {
        type: 'light',
        // primary: {
        //     main: '#fdb913',
        // },
        // secondary: {
        //     main: '#000000',
        // },
    },
    typography: {
        // Responsive typography for headings
        h4: {
            fontSize: '1.5rem',
            '@media (min-width:600px)': {
                fontSize: '1.75rem',
            },
            '@media (min-width:900px)': {
                fontSize: '2rem',
            },
        },
        h5: {
            fontSize: '1.25rem',
            '@media (min-width:600px)': {
                fontSize: '1.4rem',
            },
            '@media (min-width:900px)': {
                fontSize: '1.5rem',
            },
        },
        h6: {
            fontSize: '1rem',
            '@media (min-width:600px)': {
                fontSize: '1.15rem',
            },
            '@media (min-width:900px)': {
                fontSize: '1.25rem',
            },
        },
    },
    components: {
        MuiButton: {
            defaultProps: {
                size: 'small',
                variant: 'outlined',
            },
        },
        MuiTable: {
            defaultProps: {
                size: 'small',
            },
        },

        // Disable input field auto-complete
        MuiTextField: {
            defaultProps: {
                autoComplete: 'off',
            },
        },
        MuiOutlinedInput: {
            defaultProps: {
                autoComplete: 'off',
            },
        },
        MuiInputBase: {
            defaultProps: {
                autoComplete: 'off',
            },
        },
    },
});

export default Theme;